import { WingViewModelTypeDecorator, BaseWingViewModel } from '@nts/std';
import { DashBoardLayoutOrchestratorViewModel } from '../dash-board-layout.orchestrator-view-model';

@WingViewModelTypeDecorator(DashBoardWingViewModel)
export class DashBoardWingViewModel extends BaseWingViewModel<DashBoardLayoutOrchestratorViewModel> {
}
